import Headroom from 'headroom.js';

/**
 * Initializes headroom js on the header, to make it sticky and
 * create the app-like slide-in and -out behavior.
 *
 * @param $header
 */
const initHeader = ($header) => {
    if (!$header) {
        return;
    }

    const headroom = new Headroom($header, {
        offset: 228,
        tolerance: {
            up: 0,
            down: 0,
        },
        classes: {
            initial: 'header--fixed',
            pinned: 'slide-down',
            unpinned: 'slide-up',
            top: 'top',
            notTop: 'not-top',
        },
    });

    headroom.init();
};

/**
 * Initializes headroom js on the usp bar, to make it disappear before
 * the header does.
 *
 * @param $uspBar
 */
const initUspBar = ($uspBar) => {
    if (!$uspBar) {
        return;
    }

    const headroom = new Headroom($uspBar, {
        offset: 0,
        tolerance: 0,
        classes: {
            initial: 'usp-fixed',
            top: 'top',
            notTop: 'not-top',
        },
    });

    headroom.init();
};

const initFilter = ($filter) => {
    if (!$filter) {
        return;
    }

    const headroom = new Headroom($filter, {
        offset: $filter.offsetTop + $filter.offsetHeight,
        tolerance: {
            up: 0,
            down: 0,
        },
        classes: {
            initial: 'filter--fixed',
            pinned: 'slide-down',
            unpinned: 'slide-up',
            top: 'top',
            notTop: 'not-top',
        },
    });

    headroom.init();
};

/**
 * Calculates and sets a margin on the body to account for the size of sticky
 * elements, so that the elements do not overlap the content.
 *
 * @param $elements
 */
const setBodyOffset = (...$elements) => {
    const offset = $elements.reduce((offset, $element) => {
        if (!$element) {
            return offset;
        }

        return offset + $element.getBoundingClientRect().height;
    }, 0);

    document.body.style.marginTop = `${offset}px`;
};

(() => {
    const $header = document.querySelector('.header-wrapper');
    const $filterSearch = document.querySelector('.search-page .cms-element-sidebar-filter');
    const $filterPL = document.querySelector('.product-list-filters .cms-element-sidebar-filter');
    const $uspBar = document.querySelector('.sm-usp');

    initHeader($header);
    initFilter($filterSearch);
    initFilter($filterPL);
    initUspBar($uspBar);
    setTimeout(() => {
        setBodyOffset($header, $uspBar);
    }, 200);

    window.addEventListener('breakpoint', () => {
        setBodyOffset($header, $uspBar);
    });
})();
